var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoScenariosWt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_copy_12",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.179,
    height: 30.184,
    viewBox: "0 0 30.179 30.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M2.163,0H14.2a2.165,2.165,0,0,1,2.163,2.163V28.021A2.165,2.165,0,0,1,14.2,30.184H2.163A2.17,2.17,0,0,1,0,28.015V2.163A2.161,2.161,0,0,1,2.163,0Z",
    transform: "translate(0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M325.667,81.38l2.2-.973a1.834,1.834,0,0,0,1.09-1.668V60.809a1.812,1.812,0,0,0-1.09-1.668l-2.2-.973a.689.689,0,0,0-.908.354.651.651,0,0,0-.059.277v21.95a.687.687,0,0,0,.69.69A.633.633,0,0,0,325.667,81.38Z",
    transform: "translate(-305.562 -54.685)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M444.2,115.961v15.207a.691.691,0,0,0,.69.69.738.738,0,0,0,.295-.065l1.963-.925a1.829,1.829,0,0,0,1.049-1.65V117.912a1.819,1.819,0,0,0-1.049-1.65l-1.963-.925a.691.691,0,0,0-.919.33A.738.738,0,0,0,444.2,115.961Z",
    transform: "translate(-418.018 -108.475)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoScenariosWt);
export default __webpack_public_path__ + "static/media/ico_scenarios_wt.45510c47b4a7db3bc52079e72fc48cf0.svg";
export { ForwardRef as ReactComponent };